import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';


export default function initGlightbox() {
   

     // Prevenir redirecciones
     const links = document.querySelectorAll('.glightbox');
     links.forEach(link => {
         link.addEventListener('click', (e) => {
             e.preventDefault();
         });
     });

    const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: false,
        keyboardNavigation: true,
        loop: true,
        autoplayVideos: false,
       
        plyr: {
            config: {
                ratio: '16:9',
                fullscreen: {
                    enabled: true,
                    iosNative: true
                },
                youtube: {
                    noCookie: true,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false,
                    transparent: false
                }
            }
        }
    });


 
  
    return lightbox;
   
} 
